import { backlogFulfillmentValidate } from "../../application/dtos/backlog_fulfillment_validate";

export class BacklogFulfillmentEntity {
    constructor({ fulfillment }){
        this.fulfillment = fulfillment;
    }

    isValid() {
        return backlogFulfillmentValidate(this);
    }
}